import axios from "@/plugins/axios";
import * as reviews from "./reviews";
import * as expectations from "./expectations";
import * as inquires from "./inquires";

let url = "/api/v1/shop/products";

export const products = {
    ...reviews,
    ...expectations,
    ...inquires,
    
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
    get(data){
        return axios.get(`${url}/${data._id}`, data).then(result => result.data);
    },
}
